import { render, staticRenderFns } from "./VerifyPhoneNumber.vue?vue&type=template&id=a044ebac&scoped=true"
import script from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./VerifyPhoneNumber.vue?vue&type=style&index=0&id=a044ebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a044ebac",
  null
  
)

export default component.exports